import {
  FEATURE_FLAGS,
  getFeatureFlagsForStage,
  type FeatureFlags,
} from 'src/context/FeatureFlagsContext';

export type RiskEngineFlagSet = Pick<FeatureFlags, typeof FEATURE_FLAGS.enableRiskEngine>;

/** One predicate shared by navigation and direct-route guards. */
export function isRiskEngineEnabled(flags: Partial<RiskEngineFlagSet>): boolean {
  return flags.enableRiskEngine === true;
}

/** Mobile has no FeatureFlagProvider, so it resolves the same predicate from stage flags. */
export function isRiskEngineEnabledForCurrentStage(): boolean {
  return isRiskEngineEnabled(getFeatureFlagsForStage());
}
